export default __webpack_public_path__ + "static/media/folder.3448c1b8.svg";